import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useLoginState } from 'src/app/shared/hooks/session';

import type { PromotePageData } from '../../pageData';
import type { InitialStateParams } from '../../pageState/initialState';

import { usePrefilledGuestData } from './usePrefilledGuestData';

export function useStateInitData(): (pageData: PromotePageData) => InitialStateParams {
	const { cookies } = useUtilityContext();
	const sourceLocation = useQueryParamValue('source_location');
	const loginState = useLoginState();
	const prefillGuestUserData = usePrefilledGuestData();

	return function getStateInitData(pageData) {
		const isSecureGuest = !!(loginState === 'GUEST' && pageData.featureConfigs.doubleOptinEnabledNewUser);
		const petitionPublicSignatureCookie = cookies.get(`app_meta_public_signature_${pageData.petition.id}`);

		const isPublic = isSecureGuest ? false : !!(sourceLocation && petitionPublicSignatureCookie);

		const { enabled, userData } = prefillGuestUserData(pageData);

		return {
			isSecureGuest,
			isPublic,
			prefilledWithGuestData: enabled,
			...userData,
		};
	};
}
